/* eslint-disable */

import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

jQuery(($) => {

  // Navigate to Tabbed Sections via Select

  $('body').on('change','.select-dropdown',function() {        
    var selected = $(this).find('option:selected').attr('id');
    $('.tab-content .tab-pane').removeClass('show active');
    $(selected).addClass('show active');
  });

  // Scroll to Anchor

  $('.scroll a').click(function(event){
    event.preventDefault();
    var a = $(this.hash);
    if (a[0]) {
      $('html,body').animate({scrollTop:a.offset().top - $('#site-header').outerHeight()}, 500);
    }
  });

  //* Open All PDFs in New Window & Prevent Clickjacking *//

  $('a[href$=".pdf"]').removeAttr('download').prop('target', '_blank');

  $('a.wp-block-button__link').attr('role','link');

  $('a').each(function(){
    if ($(this).attr('target') == '_blank' && $(this).find('.sr-only').length > 0) {
      $(this).attr('rel','noopener noreferrer');
    } else if ($(this).attr('target') == '_blank' && $(this).find('.sr-only').length == 0) {
      $(this).attr('rel','noopener noreferrer');
      $(this).append('<span class="sr-only">(opens in a new window)</span>');
    }
  })

  // Change Breadcrumb Home Text Based on Language

  if ($('html').is(':lang(es-ES)')) {
    $('.site-breadcrumbs .fbc .fbc-wrap .fbc-items li:first-of-type').html('<a itemprop="item" href="http://panamericansilver.com/es/">Inicio</a>');
  }

  // Replace Text for Translations

  if ($('html').is(':lang(en-CA)')) {
    $('.user-registration-MyAccount-content p:contains("Not")').html("");
  }

  if ($('html').is(':lang(es-ES)')) {
    $('button:contains("Load Quiz")').html('Cargar cuestionario');
    $('button:contains("Save Quiz")').html('Guardar cuestionario');
    $('.user-registration-MyAccount-content p:contains("Not")').html('');
    $('.user-dashboard-list th:contains("Quiz Name")').html('Nombre del cuestinario');
    $('.user-dashboard-list th:contains("Certificate Link")').html('Enlace al certificado');
    $('.user-dashboard-list th:contains("Score")').html('Puntaje');
    $('.user-dashboard-list a:contains("View")').html('Vista');
    $('.user-dashboard-list a:contains("Download Certificate")').html('Descargar certificado');
    $('select option[value="MX"]').text('México');
    $('.qmn_certificate_link').html('Descargar certificado');
  };

  // Smooth Scroll to Anchor Link

  $(document).on('click', '.scroll', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

  AOS.init({
    duration: 1000,
     once: true,
  });
});
